import { Ng2StateDeclaration } from '@uirouter/angular';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiAppearanceListViewViewComponent } from '@fi-app/appearance/list-view/list-view-view/list-view-view.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAppearanceListViewViewState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.ListView.View,
    url: '/',
    views: {
        '@': {
            component: FiAppearanceListViewViewComponent,
        },
    },
    resolve: {
        pageTitle: [PageTitleService, FiAppearanceListViewViewStateResolvePageTitle],
        listViewSettings: [ListViewSettingsService, FiAppearanceListViewViewStateResolveListViewSettings],
    },
};

export function FiAppearanceListViewViewStateResolvePageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitleByTextId('common.appearance');
}

export function FiAppearanceListViewViewStateResolveListViewSettings(settingsService: ListViewSettingsService) {
    return settingsService.getSettings([ObjectTypes.Document, ObjectTypes.MediaBank, ObjectTypes.User]);
}
